import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
import { withBuyonlineAccessToken } from '../core/buy-insurance-access.util';
import { Observable, BehaviorSubject } from 'rxjs';
import { pad, secConverter } from '../core/utilities';

import { BaseComponents } from '../base.component';

@Injectable()
export class GenerateOTPService extends BaseComponents{

  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient, 
    public wpTokenService: WpTokenService, 
    //private logger: NGXLogger
  ) {
    super(injectorObj);
    this.countdownSecond = new BehaviorSubject<string>(this.countdownText);
  }

  private VERIFY_TOKEN_EXPIRE = false;
  private countdownSecond: BehaviorSubject<string>;
  private countdown = -1;
  public countdownText:string = '';
  private myVar: any = null;
  getCountdown(): Observable<string> {
    return this.countdownSecond.asObservable();
  }
  setCountdown(countdown:number,isResetCountdown:boolean = false): void {
    if(this.countdown==-1 || isResetCountdown === true){
      this.countdown = countdown;
    }
    if (this.myVar == null) {
      this.myVar = setInterval(() => {
        this.countdown--;
        if (this.countdown > -1) {
          let convertedTime = secConverter(this.countdown, "sec");
          this.countdownText = ''+pad(convertedTime.minutes)+':'+pad(convertedTime.seconds);
          this.countdownSecond.next(this.countdownText);
        } else {
          clearInterval(this.myVar);
          this.myVar = null;
        }
      }, 1000);
    }
  }

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if (this.VERIFY_TOKEN_EXPIRE) {
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    return param;
  }

  output(result: any) {
    return result;
  }

  connector(param: any) {
    const url = `${environment.endpointBackend}/api/generateOTP`;
    // A buy-online OTP needs the access token of its referenceID.
    const body = param?.referenceID
      ? withBuyonlineAccessToken(param.referenceID, this.input(param))
      : this.input(param);
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // Core Function ! No modify
  exec(param: {templateId?:string,insureNotifyID?:string,referenceID?:string}) {
    const self = this;
    return new Promise(function (resolve, reject) {
      if (!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()) {
        self.connector(param).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            resolve(self.output(res['body']));
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus: 401,
          message: 'token is expired'
        });
      }
    });
  }

}
